import axios from "axios";

// get the calendar (tuerchen) data, authorization with token
export const getCalendarData = () => {
  // https://mocki.io/v1/8a6662c1-5c04-4f8f-a030-4bbb75a6642f https://www.krimikollegen.de/adventskalender/json https://www.edelkids.de/adventskalender/json https://mocki.io/v1/9be059db-c411-47a6-8fa5-f1b3933e4d5b https://mocki.io/v1/947fe7e7-080e-4d5b-a57f-12d49c5e80a0
  const url =  "/adventskalender/json";
  return axios
    .get(url)
    .then(function (response) {
      //console.log(response.data);
      return response;
    })
    .catch(function (error) {
      // handle error
      //console.log(error);
      if (error.response) {
        //console.log(error.response.data);
        // /console.log(error.response);
        //console.log(error.response.headers);
        return error.response;
      }
    });
};
